// Shared sandbox adapter: flattens SAMPLE_TOURNAMENT into GolfGamesScorecard's
// Player[] shape ({ id, name, handicap, scores:[18], team }) so the ported
// betting-game engines run on the same in-code sample. Sandbox-only; imports
// only sibling gg files. No live imports, no Firebase.
import { SAMPLE_TOURNAMENT } from './sampleTournament.js'
import { strokesOnHole } from './ggHandicap.js'

export const samplePars = () => SAMPLE_TOURNAMENT.info.pars
export const sampleStrokeIndex = () => SAMPLE_TOURNAMENT.info.strokeIndex

/** 12 players (2 per sample team) with per-hole gross scores + playing handicap. */
export function samplePlayers() {
  const out = []
  for (const flight of Object.values(SAMPLE_TOURNAMENT.flights || {})) {
    for (const [tid, t] of Object.entries(flight.teams || {})) {
      const names = t.info?.players || []
      const phs = t.info?.playingHandicaps || []
      names.forEach((nm, i) => {
        const key = i === 0 ? 'p1score' : 'p2score'
        const scores = Array.from({ length: 18 }, (_, h) => {
          const v = t.scores?.[h + 1]?.[key]
          return Number.isFinite(Number(v)) ? Number(v) : null
        })
        out.push({ id: `${tid}_p${i + 1}`, name: nm, handicap: Number(phs[i]) || 0, scores, team: tid })
      })
    }
  }
  return out
}

/** Net copy of a player list: each gross score minus that player's strokes on the hole. */
export function netPlayers(players, strokeIndex = sampleStrokeIndex()) {
  return (players || []).map((p) => ({
    ...p,
    scores: p.scores.map((s, h) => (s == null ? null : s - strokesOnHole(p.handicap, h, strokeIndex))),
  }))
}

/** Group the flat player list into its sample teams → Player[][] (for team games). */
export function sampleTeams() {
  const byTeam = {}
  for (const p of samplePlayers()) (byTeam[p.team] ||= []).push(p)
  return Object.values(byTeam)
}
